import { EPSILON, TRIGONOMETRIC_EPSILON } from './constant';
export default class Point {
    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }
    clone() {
        return new Point(this.x, this.y);
    }
    equals(point) {
        return this === point || (this.x == point.x && this.y == point.y);
    }
    add(point) {
        return new Point(this.x + point.x, this.y + point.y);
    }
    subtract(point) {
        return new Point(this.x - point.x, this.y - point.y);
    }
    multiply(point) {
        return new Point(this.x * point.x, this.y * point.y);
    }
    divide(point) {
        return new Point(this.x / point.x, this.y / point.y);
    }
    getDistance(point) {
        const x = point.x - this.x;
        const y = point.y - this.y;
        return Math.sqrt(x * x + y * y);
    }
    normalize(length = 1) {
        const current = this.getLength();
        const scale = current == 0 ? 0 : length / current;
        return new Point(this.x * scale, this.y * scale);
    }
    isZero() {
        return (this.x >= -EPSILON && this.x <= EPSILON) && (this.y >= -EPSILON && this.y <= EPSILON);
    }
    isCollinear(point) {
        const x1 = this.x;
        const y1 = this.y;
        const x2 = point.x;
        const y2 = point.y;
        return Math.abs(x1 * y2 - y1 * x2) <= Math.sqrt((x1 * x1 + y1 * y1) * (x2 * x2 + y2 * y2)) * TRIGONOMETRIC_EPSILON;
    }
    isClose(point, tolerance) {
        if (point)
            return this.getDistance(point) <= tolerance;
        return false;
    }
    getLength() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    dot(point) {
        return this.x * point.x + this.y * point.y;
    }
    negate() {
        return new Point(-this.x, -this.y);
    }
}
//# sourceMappingURL=point.js.map